export const services = [
  {
    id: 1,
    name: 'Replace a cambelt',
  },
  {
    id: 2,
    name: 'Replace oil and filter',
  },
  {
    id: 3,
    name: 'Replace front brake pads and discs',
  },
  {
    id: 4,
    name: 'Replace rare brake pads and discs',
  },
];
